module.exports = __webpack_public_path__ + "img/birth-bonus.bb630875.png";